import React from 'react'
import styled from 'styled-components'
import { RouteDirection } from '../../../../constants/RouteDirection'
import { Route } from '../../../../model/Event/Room/Route'

const Wrapper = styled.div`
  font-size: 3rem;
  margin-right: 1rem;
  /* float: right; */
  /* display: flex;
  justify-content: center;
  align-items: center;
  align-content: center; */
`

interface IArrowProps {
  direction: string
}

const Arrow = styled.span<IArrowProps>`
  display: block;
  width: 5rem;
  height: 5rem;
  transform: rotate(${(props) => {
    switch (props.direction) {
      case RouteDirection.N:
        return 90
      case RouteDirection.E:
        return 180
      case RouteDirection.S:
        return 270
      case RouteDirection.SE:
        return 225
      case RouteDirection.NE:
        return 135
      case RouteDirection.SW:
        return 315
      case RouteDirection.NW:
        return 45
      default:
        return 0
    }
  }}deg);

  svg {
    max-width: 100%;
    max-height: 100%;
  }

  rect, path {
   fill: ${(props) => props.theme.colorArrows};
  }
`

interface IProps {
  route: Route
}

const Direction = ({ route }: IProps) => (
  <Wrapper>
    <Arrow direction={route.direction}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="110"
        height="91"
        viewBox="0 0 110 91"
      >
        <rect x="1" y="36" width="109" height="20" rx="10" ry="10"/>
        <path d="M3.1,38.253L37.753,3.6A10,10,0,0,1,51.9,17.747L17.247,52.4A10,10,0,0,1,3.1,38.253Z"/>
        <path d="M3.1,52.747L37.753,87.4A10,10,0,0,0,51.9,73.253L17.247,38.6A10,10,0,0,0,3.1,52.747Z"/>
      </svg>
    </Arrow>
    {route.distance}
  </Wrapper>
)

export default Direction
